module.exports = __webpack_public_path__ + "static/media/thermohug-4.3c342070.jpg";